// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__1R7-8","title":"ClientInsurance_title__2q6vg","itemText":"ClientInsurance_itemText__1Ll4e"};